import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  timefilterBtn: {
    minWidth: '8rem',
    justifyContent: 'space-between',
    borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
    borderRightColor: 'transparent',
    padding: theme.spacing(0.5, 1.5, 0.5, 1),
    '.MuiButton-endIcon': {
      marginLeft: theme.spacing(0.25)
    }
  },
  filterList: {
    width: '27rem'
  },
  presetList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2)
  },
  presetListItem: {
    minWidth: '9rem',
    justifyContent: 'flex-start'
  },
  customTime: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center',
    padding: theme.spacing(2, 2),
    input: {
      padding: theme.spacing(0, 1),
      minHeight: '2rem',
      fontSize: '0.875rem'
    },
    '.MuiInputBase-root': {
      paddingRight: theme.spacing(0.5)
    }
  }
}));

export default useStyles;
